var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "panel-container show" }, [
    _c(
      "div",
      { staticClass: "panel-content" },
      [
        _c("fileloader", {
          key: "file_loader_mem",
          attrs: {
            files: _vm.loaded_files,
            "enable-preview": false,
            validate_geo: false,
            can_del: true,
            doc_type: "internaldoc",
            doc_id: _vm.doc.id,
            trigger_load: _vm.load_trigger,
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("b-table", {
          staticClass: "table-responsive-lg",
          attrs: { striped: "", items: _vm.doc.files, fields: _vm.fields },
          scopedSlots: _vm._u([
            {
              key: "head(link)",
              fn: function (data) {
                return [
                  _c("span", {
                    staticClass: "fs-xl text-center",
                    domProps: { innerHTML: _vm._s(data.label) },
                  }),
                ]
              },
            },
            {
              key: "head(id)",
              fn: function (data) {
                return [
                  _c("span", {
                    staticClass: "fs-xl text-center",
                    domProps: { innerHTML: _vm._s(data.label) },
                  }),
                ]
              },
            },
            {
              key: "cell(link)",
              fn: function (data) {
                return [
                  _c(
                    "span",
                    {
                      staticClass: "get_file cursor-pointer",
                      on: {
                        click: function ($event) {
                          return _vm.get_file(data.item)
                        },
                      },
                    },
                    [_c("i", { staticClass: "fal fs-xl fa-save save_me" })]
                  ),
                ]
              },
            },
            {
              key: "cell(id)",
              fn: function (data) {
                return [
                  _c(
                    "span",
                    {
                      staticClass: "get_file cursor-pointer",
                      on: {
                        click: function ($event) {
                          return _vm.remove_file(data.item)
                        },
                      },
                    },
                    [_c("i", { staticClass: "fal fs-xl fa-trash save_me" })]
                  ),
                ]
              },
            },
          ]),
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }